import {
  DataPeriod,
  DataStudentEntry,
  EvidenceColumn,
  EvidenceColumnGroup,
  EvidencePeriodData,
  EvidenceType,
  RaceInfo,
  School,
  Student,
  TeacherClass,
} from "../../../../../../store/onboarding/types";
import { DataSortState } from "../../../../../../store/dataSort/types";
import { InterventionGroup, StudentInterventionGroups } from "../../../../../../store/onboarding/cases/types";
import { Grade } from "../../../../../../store/groups/types";
import { RouteComponentProps } from "react-router";
import { PopupDismissal, UserInfo } from "../../../../../../store/auth/types";
import { getInterviews } from "../../../../../../store/onboarding/actions";

/**
 * Types, enums and constants used by EvidenceTable.tsx, extracted verbatim
 * (no logic changes) purely to reduce the size of the main component file.
 */

export type PropsFromState = {
  errors: {
    getEvidenceData?: string;
    addAssessmentToDataPeriod?: string;
    addStudentsToDataPeriod?: string;
    setValueOfDSEtoDataPeriod?: string;
    updateValueOfDSEtoDataPeriod?: string;
    setDiagnosticFollowUptoDataPeriod?: string;
    deleteDiagnosticFollowUptoDataPeriod?: string;
    uploadAssessmentData?: string | Array<any>;
    uploadUndefinedAssessmentData?: string | Array<any>;
    uploadEvidenceData?: string | Array<any>;
    deleteEvidenceColumnsGroup?: string;
    changeStudentDSEGrade?: string;
    addTargetBehaviorToDataPeriod?: string;
    addStudentBehaviorsToDataPeriod?: string;
    updateStudentDetails?: string;
    addStudents?: string | Array<any>;
    updateCustomColorCriteria?: string;
    updateAssessment?: string | Array<any>;
  };
  isLoading: {
    getEvidenceData: boolean;
    getDataPeriods: boolean;
    addAssessmentToDataPeriod: boolean;
    addStudentsToDataPeriod: boolean;
    updateStudentDetails: boolean;
    setValueOfDSEtoDataPeriod: boolean;
    updateValueOfDSEtoDataPeriod: boolean;
    setDiagnosticFollowUptoDataPeriod: boolean;
    deleteDiagnosticFollowUptoDataPeriod: boolean;
    uploadAssessmentData: boolean;
    uploadUndefinedAssessmentData: boolean;
    uploadEvidenceData: boolean;
    deleteEvidenceColumnsGroup: boolean;
    changeStudentDSEGrade: boolean;
    addStudentSkills: boolean;
    deleteDataStudentEntry: boolean;
    addTargetBehaviorToDataPeriod: boolean;
    addStudentBehaviorsToDataPeriod: boolean;
    addExistingBehaviorEcgToDataPeriod: boolean;
    addBehaviorScreenerEcgToDataPeriod: boolean;
    assignTeachersToStudent: boolean;
    updateClassesLinkedToStudent: boolean;
    updateCustomColorCriteria: boolean;
    updateAssessment: boolean;
    createDiagnosticInfoColumn?: boolean;
    getSchoolsList?: boolean;
    addStudents: boolean;
  };
  evidencePeriodData?: EvidencePeriodData;
  currentDataPeriod?: DataPeriod;
  teacherIdFilter?: number[];
  schoolIdsFilter?: number[];
  teacherIdsFilter?: number[];
  selectedClass?: TeacherClass;
  selectedStudent?: Student;
  newGroupStudents: Array<Student>;
  gradeLevelFilter?: Grade[];
  classFilter?: number[];
  studentsFilter?: string;
  isEnterSpecificSkillActive: boolean;
  studentInterventionGroups: StudentInterventionGroups;
  hasDiagnosticInfo: boolean;
  raceFilter: string[];
  raceOtherFilter: string[];
  genderFilter: string[];
  specialEducationFilter: boolean | undefined;
  ellFilter: boolean | undefined;
  sldFilter: boolean | undefined;
  freeOrReducedLunchFilter: boolean | undefined;
  schools: School[];
  showTopBar?: boolean;
  isCompressedViewOfDataTable?: boolean;
  showGroupingStudentInfo?: boolean;
  dataSort?: DataSortState;
  teacherClassStudent?: any;
  userInfo?: UserInfo;
  raceInfo?: RaceInfo;
  isDataFilterApplied: boolean;
  loadTableFromSetGoal: boolean;
  userDismissPopupDetails?: PopupDismissal;
};

export type DispatchProps = {
  getDataPeriods: () => any;
  getTeachers: () => any;
  getSchools: () => any;
  getEvidenceInDataPeriod: (dataPeriodId?: number) => any;
  deleteEvidenceColumnsGroup: (evidenceColumnGroupId: number) => any;
  openViewBenchmarksModal: () => any;
  hideViewBenchmarksModal: () => any;
  hideSkillFocusesModal: () => any;
  setValueOfDSEtoDataPeriod: (
    evidenceColumnGroupId: number,
    dse: DataStudentEntry
  ) => any;
  updateValueOfDSEtoDataPeriod: (
    evidenceColumnGroupId: number,
    dseId: number,
    dse: DataStudentEntry
  ) => any;
  setDiagnosticFollowUptoDataPeriod: (
    evidenceColumnGroupId: number,
    dse: DataStudentEntry
  ) => any;
  deleteDiagnosticFollowUptoDataPeriod: (entryId: number) => any;
  addStudentsToNewGroup: (students: Array<Student>) => any;
  changeStudentDSEGrade: (
    dataPeriodId: number,
    studentId: number,
    grade: Grade
  ) => any;
  clickGotIt: () => any;
  openLoadKeyModal: () => any;
  getInterviews: typeof getInterviews;

  getAllClasses: (dataPeriodId: number, grade?: string) => any;
  getClassesLinkedToStudent: (studentId: number) => any;
  showConfirmDialog: (confirmObj: any) => any;
  deleteStudentEntry: (studentEntryId: number) => any;
  getRaceInfo: (currentDataPeriodId: number) => any;
  columnSortApplied: (isColumnSortApplied: boolean) => any;
  dataFilterApplied: (isDataFilterApplied: boolean) => any;
  resetPagination: () => any;
  resetFilterAction: () => any;
  resetSortAction: () => any;
};

export type DisplayedColumn = {
  evidenceColumnGroupId: number;
  evidenceColumns: Array<{
    evidenceColumnId: number;
    show: boolean;
  }>;
};

export type StudentRowEditing = {
  studentId: number;
  evidenceColumnGroups: Array<EvidenceColumnGroupEditing>;
};

export type EvidenceColumnGroupEditing = {
  evidenceColumnGroupId: number;
  evidenceColumnEditingStatuses: Array<EvidenceColumnEditingStatus>;
};

export type EvidenceColumnEditingStatus = {
  evidenceColumnId: number;
  isEdited: boolean;
  value?: number | boolean;
};

export type OwnProps = {
  isPlanning?: boolean;
  isReadonly?: boolean;
  interventionGroup?: InterventionGroup;
  minimal?: boolean;
  isDataInterview?: boolean;
  //fromSetGoalModal?: boolean;
  filterDisplayedGroups?: (
    dataPeriodId: number,
    evidenceColumnGroupId: number
  ) => any;
};

export type MatchParams = {
  tabName: string;
};

export type Props = OwnProps &
  RouteComponentProps<MatchParams> &
  PropsFromState &
  DispatchProps;

export type Sorting = {
  column?: string;
  measurement?: {
    evidenceColumnGroupId: number;
    evidenceColumnId: number;
  };
  direction: "desc" | "asc";
  sortingCount: number;
  evidenceType: EvidenceType | undefined;
};

export type State = {
  headerHeight: number;
  dataRowHeight: number;
  groupHeaderHeight: number;
  selectedEvidence?: {
    assessmentName: string;
    evidenceColumnGroupId: number;
    evidenceColumn: EvidenceColumn;
    isBehaviorPrimaryScreening: boolean;
    useGradeSpecificColorCriteria: boolean;
    withReadingAlgorithm: boolean;
    isSystemAssessment: boolean;
  };
  selectedStudents: Array<Student>;
  evidencePeriodData?: EvidencePeriodData;
  displayedColumns: Array<DisplayedColumn>;
  studentEditingRows: Array<StudentRowEditing>;
  sorting: Sorting;
  tableWidth?: number;
  tableHeight?: number;
  scrollToRow?: number;
  showDropDown: boolean;
  isDistrictOwner?: boolean;
  columnWidths: { [key: string]: number };
};

export const gradeLevels = [
  "K",
  "G1",
  "G2",
  "G3",
  "G4",
  "G5",
  "G6",
  "G7",
  "G8",
  "G9",
  "G10",
  "G11",
  "G12",
];

export const anotherOrderArray: any[] = [3, 7, 4];
export const META_GROUP_TYPE_NEEDS = "meta_group_needs";

export enum ColumnNames {
  STUDENT = "student",
  TEACHER = "teacher",
  GRADE = "grade",
  CLASS = "class",
  STUDENT_ROW = "student_rows",
}
